import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NvLogoModule } from 'Src/nvps-libraries/design/nv-logo/nv-logo.module';
import { SharedServicesModule } from '../../../shared/services/shared.services.module';
import { PrivacyAndTermsComponent } from './privacy-and-terms.component';

@NgModule({
  imports: [CommonModule, MatGridListModule, MatListModule, MatSidenavModule, NvLogoModule, SharedServicesModule],
  declarations: [PrivacyAndTermsComponent],
})
export class PrivacyAndTermsModule {}
